import axios from 'lib/axios'
import { CPILibraryItem } from 'models'

const basePath = '/api/v3/cpis'

export const CpiServiceV3 = {
  getAllCpis: async (): Promise<CPILibraryItem[]> => {
    const { data: responseData } = await axios.get(basePath)
    return responseData.data.cpis
  },

  searchCpis: async (params: Record<string, any>): Promise<CPILibraryItem[]> => {
    const { data: responseData } = await axios.get(`${basePath}/search`, { params })
    return responseData.data.cpis
  },

  getCpiDetails: async (cpiName: string): Promise<CPILibraryItem> => {
    const { data: responseData } = await axios.get(`${basePath}/${cpiName}/details`)
    return responseData.data
  }
}
